import { FormControl } from '@mui/material'
import React, { memo } from 'react'

import CustomFormLabel from '../forms/customElements/CustomFormLabel'
import PopoverHelpText from '../PopoverHelpText/PopoverHelpText'
import Text from '../text/Text'
import InputHelperText from './InputHelperText'

const FileField = ({
  label,
  id,
  errorMessage,
  onChange,
  accept,
  helpText,
  desc,
  multiple = false,
  ...restProps
}) => {
  const error = Boolean(errorMessage)
  return (
    <FormControl fullWidth error={error}>
      <CustomFormLabel htmlFor={id}>
        {label}
        {helpText && <PopoverHelpText label={helpText} />}
      </CustomFormLabel>
      {desc && (
        <Text label={desc} variant='body2' color='textprimary' sx={{ mb: 2 }} />
      )}
      <input
        type='file'
        accept={accept}
        id={id}
        onChange={onChange}
        multiple={multiple}
      />
      <InputHelperText {...restProps} errorMessage={errorMessage} />
    </FormControl>
  )
}

export default memo(FileField)
